import testWebpSupport from '@assets/utils/testWebpSupport';
import { THUMBNAIL_SIZE_LARGE } from '@embed/styled';
let WEBP_SUPPORTED = undefined;
testWebpSupport((result) => {
    WEBP_SUPPORTED = !!result;
});
const resizeThumbnailUrl = (url, options) => {
    var _a;
    if (!url) {
        return '';
    }
    if (url &&
        (url.match('default_avatar') || url.match('default_event_trailer'))) {
        // User has not set an avatar, the default avatar returned in api cannot be
        // dynamically resized. Same goes with default event trailer poster.
        return url;
    }
    if (url.includes('/000')) {
        url = url.replace('/000/', '/540/');
    }
    const defaults = {
        format: WEBP_SUPPORTED ? 'webp' : 'jpg',
        quality: 62,
        size: [THUMBNAIL_SIZE_LARGE[0], THUMBNAIL_SIZE_LARGE[1]],
    };
    const { format, quality, size } = Object.assign(Object.assign({}, defaults), (options || {}));
    let append = '';
    append += quality ? `.${quality}` : '';
    append += format ? `.${format}` : '';
    const match = url.match(/\/transcoded\/(?<width>\d{3,4})\//i);
    let output = '';
    if (size) {
        if ((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.width) {
            output = url.replace(`/${match.groups.width}/`, `/${size[0]}/`) + append;
        }
        else {
            output =
                url.replace(/\/(original|\d{3,4}[_|x]\d{3,4})\//, `/${size[0]}_${size[1]}/`) + append;
        }
    }
    else {
        output = url + append;
    }
    return output;
};
export default resizeThumbnailUrl;
